/**
 * Offline sync UX strings; transport classification is shared in `httpTransportFailure.ts`.
 */

export {
  parseHttpStatusFromErrorMessage as parseHttpStatusFromSyncErrorMessage,
  isRetryableHttpTransportThrownFailure as isRetryableSyncTransportFailure,
} from '@core/domain/utils/httpTransportFailure.ts';

/**
 * Maps thrown values to a stable, user-visible Spanish message for sync UI.
 */
export function formatSyncFailureUserMessage(error: unknown): string {
  const raw =
    error instanceof Error
      ? error.message
      : typeof error === 'string'
        ? error
        : String(error);

  let message = raw;
  if (
    message === 'Failed to fetch' ||
    message === 'TimeoutError' ||
    message === 'The operation timed out.' ||
    /^network error$/i.test(message.trim())
  ) {
    message =
      'Fallo de conexión a internet durante el envío. Verifique su red y vuelva a intentarlo.';
  } else if (message.includes('HTTP 413')) {
    message =
      'El tamaño de los datos a enviar es demasiado grande para el servidor (HTTP 413). Intente sincronizar con menos registros.';
  } else if (message.includes('HTTP 401')) {
    message =
      'No autorizado por el servidor (HTTP 401). Defina SYNC_DOWNLOAD_BEARER_TOKEN en la compilación o inicie sesión para enviar el mismo token que la API en descarga y envío.';
  } else if (message.includes('HTTP 409')) {
    message =
      'Conflicto de idempotencia (HTTP 409): esta clave ya se usó con otro contenido. Genere un nuevo intento de sincronización desde la app.';
  } else if (message.startsWith('HTTP ')) {
    message = `Fallo del servidor (${message}). Intente más tarde o contacte a soporte.`;
  }

  return (
    message ||
    'No se pudo completar la sincronización. Compruebe la red, CORS del servidor y el tamaño del envío.'
  );
}
